module.exports = __webpack_public_path__ + "static/media/optibolt-4.ec5dd8be.jpg";